export var resizeImage = function resizeImage(filename, resizeValue) {
  if (filename.split(".").pop() === "gif") return filename;
  var dotIndex = filename.lastIndexOf(".");
  return "".concat(filename.substring(0, dotIndex < 0 ? filename.length : dotIndex)).concat(resizeValue || "", ".webp");
};